import React from 'react';
import { connect } from 'react-redux';

import Page from '../../page.jsx';
import SuggestDifferentResolution from '../../resolution/suggestDifferentResolution.jsx';
import { data as paymentDataPropTypes } from '../../paymentPropTypes.js';

const SuggestDifferentResolutionPage = ({ payment }) => (
    <Page heading="Foreslå en annen løsning">
        <SuggestDifferentResolution payment={payment} />
    </Page>
);

SuggestDifferentResolutionPage.propTypes = {
    payment: paymentDataPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        payment: state.payment.data,
    };
}

export default connect(mapStateToProps)(SuggestDifferentResolutionPage);



// WEBPACK FOOTER //
// ./safeTrade/seller/resolution/suggestDifferentResolutionPage.jsx